// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lz65","content":"styles_content__M5jvT","row":"styles_row__y7z6U","footer":"styles_footer__2V6UQ","phraseLength":"styles_phraseLength__2RhBC"};